<template>
	<div class="filter-panel">
        <!-- <div v-if="isLoading">
            <base-preloader-gif-v2 class="filter-panel__item-preloader"/>
        </div> -->
        <span class="filter-panel__border"></span>

        <div class="filter-panel__item-container">
            <base-preloader-skeleton
                v-if="isLoading && !isFilterOpen"
                class="filter-panel__item-preload"
            />

            <LinceButton 
                class="filter-panel__select"
                @click="onOpenFilterLocations"
            >
                <span class="filter-panel__select-title">
                    {{ filterLocationsPreviewTitle }}
                </span>
            </LinceButton>

            <LinceFilterLocation 
                v-if="isFilterLocations"
                :modalWidth="'820px'"
                :config="filterLocationsConfig"
                :locations="filterLocations"
                :locationsSelected="filterLocationsSelectedProxy"
                :locationsSearchValue="filterLocationsSearchValue"
                :locationsFound="filterLocationsFound"
                @searchLocations="onSearchFilterLocations"
                @addCity="onAddCityFilterLocations"
                @closeModal="onCloseFilterLocations"
                @applyFilter="onApplyFilterLocations"
            />
        </div>

        <div class="filter-panel__item-container">
            <base-preloader-skeleton
                v-if="isLoading && !isFilterOpen"
                class="filter-panel__item-preload"
            />
            
            <LinceDatepickerMonth
                ref="refLinceDatepickerMonth"
                :isVisible="isDatepickerOpen"
                :isMultiple="true"
                :position="'left'"
                :padding="0"
                :accessDates="accessDates"
                :checkedDates="checkedDates"
                class="filter-panel__date-wrapper"
                @changeVisible="onChangeVisibleDatepicker"
                @cancel="closeDatepicker"
                @approve="onApproveDatepicker"
            >
                <template #preview>
                    <LinceButton
                        class="filter-panel-date"
                        :active="isDatepickerOpen"
                    >
                        <span class="filter-panel-icon icon-tabler-icon-calendar-minus" />
                        
                        <span class="filter-panel-date__title">
                            {{dateTitle}}
                        </span>
                    </LinceButton>
                </template>
            </LinceDatepickerMonth>
        </div>

        <div class="filter-info">
            <base-preloader-skeleton
                v-if="isLoading && !isFilterOpen"
                class="filter-panel__item-preload"
            />
            <div
                class="filter-info__wrapper"
                :class="{ getFilterButtonClasses, 'filter-info__wrapper--resizing' :isResize }"
            >
                <LinceButton
                    :class="{'filter-info-btn_active': isFilterOpen}"
                    class="filter-info-btn"
                    :active="isFilterOpen"
                    @click="onFilterToggle"
                >
                    <span
                        v-if="!isFilterOpen"
                        class="filter-info-icon icon-tabler-icon-filter"
                    >
                    </span>
                    <LinceIconClose
                        v-if="isFilterOpen"
                        :width="18"
                        :height="18"
                    />
                    <div 
                        v-if="isFilterOpen"
                        class="filter-info-btn__text"
                    >
                        Закрыть
                    </div>
                    <!-- <span v-show="loadClientWidth > 577">Фильтр</span> -->
                </LinceButton>

                <LinceButton
                    v-if="isFilterOpen"
                    :view="'round'"
                    class="filter-info-panel__btn"
                    @click="onClear"
                >
                    <BaseIcon icon="icon-tabler-icon-eraser" size="lg" class="filter-info-panel__btn-icon" />
                    <span class="filter-info-panel__btn-title">Сбросить всё</span>
                </LinceButton>

                <div
                    ref="chipsWrap"
                    v-if="loadClientWidth > 700"
                    class="filter-info__chips-wrapper"
                    :class="{'filter-info__chips-wrapper--resizing' : isResize}">
                    <div
                        class="filter-info__chips-place"
                        v-if="hasChips"
                        :class="{'filter-info__chips-place--resizing' : isResize}"
                    >
                        <AppChips
                            ref="chips"
                            :isFilterOpen="isFilterOpen"
                            :class="{'chips--resizing' : isResize}"
                            :chips="chips"
                            :number-displayed-chips="countVisibleChips"
                            @remove="onRemoveChips"
                            @more="onFilterToggle"
                            @onRemoveAllChips="onClear"
                        />
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import AppChips from './Chips'
import BasePreloaderSkeleton from "@/components/Base/BasePreloaderSkeleton"
import BaseIcon from '../../components/Base/BaseIcon.vue';

export default {
	name: "FilterPanel",
	components: {
        AppChips,
        BasePreloaderSkeleton,
        BaseIcon
	},
    props: {
        chips: {
            type: Array,
            default: () => []
        },
        checkedDates: {
            type: Array,
            default: () => []
        },
        accessDates: {
            type: Array,
            default: () => []
        },
        cities: {
            type: Array,
            default: () => []
        },
        selectedCities: {
            type: Array,
            default: () => []
        },
        isFilterOpen: {
            type: Boolean,
            default: false
        },
        isLoading: {
			type: Boolean,
			default: false
		},
        filterLocations: {
            type: Array,
            default: () => ([])
        },
        filterLocationsSelected: {
            type: Object,
            default: () => ({
                countries: [],
                regions: [],
                cities: []
            })
        },
        filterLocationsFound: {
            type: Array,
            default: () => ([])
        }
    },
    /**
     * Находит ширину экрана браузера.
     * Вешает обработчик на изменение ширины окна браузера
     */
    mounted() {
        this.isResize = true;
        let resizeTimeout = 0;
        this.loadClientWidth = document.documentElement.clientWidth;

        window.addEventListener('resize', () => {
            if (!resizeTimeout) {
                resizeTimeout = setTimeout(() => {
                    resizeTimeout = null;
                    this.getWrapperWidth();
                }, 300);
            }
        }, false);
    },

    /**
     * Удаляем обработчик на изменение ширины окна браузера
     */
    beforeDestroy() {
        window.removeEventListener('resize', this.getWrapperWidth);
    },

    /**
     * Следим за длинной чипсов
     */
    watch: {
        chips() {
            if (this.chips.length > 0) {
                this.getVisibleChips();
            }
        },
    },

    /**
     * Данные компонента
     * @property {number} countVisibleChips - кол-во отображаемых чипсов
     * @property {boolean} isResize - динамическое изменение кол-ва отображаемых чипсов
     *                              при изменении ширины окна браузера
     * @property {number} loadClientWidth - ширина окна браузера
     */
    data() {
        return {
            isFilterLocations: false,
            months: [
				'Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн',
				'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'
			],
            monthsFull: new Map(Object.entries({
                'Янв': 'Январь',
                'Фев': 'Февраль',
                'Мар': 'Март',
                'Апр': 'Апрель',
                'Май': 'Май',
                'Июн': 'Июнь',
				'Июл': 'Июль',
                'Авг': 'Август',
                'Сен': 'Сентябрь',
                'Окт': 'Октябрь',
                'Ноя': 'Ноябрь',
                'Дек': 'Декабрь',
            })),
            isDatepickerOpen: false,
            countVisibleChips: 2,
            isResize: false,
            loadClientWidth: 0,
            filterLocationsConfig: {
                countries: { 
                    selectType: 'single',
                    isShowGroupName: false,
                },
                regions: {
                    selectType: 'single',
                    isShowGroupName: false,
                },
                cities: {
                    selectType: 'multiple',
                    isShowGroupName: true,
                }
            },
            filterLocationsSearchValue: ''
        }
    },
    computed: {
        filterLocationsSelectedProxy() {
            const filterLocationsSelectedProxy = {
                ...this.filterLocationsSelected,
                countries: this.filterLocations.map(country => country?.id ?? ''),
            };

            return filterLocationsSelectedProxy;
        },
        filterLocationsPreviewTitle() {
            const countrySelectedId = this.filterLocationsSelected?.countries[0] ?? '';
            const regionSelectedId = this.filterLocationsSelected?.regions[0] ?? '';
            const citiesSelectedIds =  this.filterLocationsSelected?.cities ?? [];

            const countrySelected = this.filterLocations.find(country => country?.id === countrySelectedId) ?? {};
            const regionSelected = countrySelected?.regions?.find(region => region?.id === regionSelectedId) ?? {};
            const citiesSelected = regionSelected?.cities?.filter(city => citiesSelectedIds.includes(city?.id ?? '')) ?? [];

            const regionSelectedName = String(regionSelected?.name ?? 'Выберите город');
            const citiesSelectedNames = citiesSelected.map(city => String(city?.name ?? ''));
            const citiesSelectedPreview = citiesSelectedNames.length > 1 ? `${citiesSelectedNames[0]} и еще ${citiesSelectedNames.length - 1}` : String(citiesSelectedNames[0] ?? 'Выберите город')

            return citiesSelectedNames.length === 0 ? regionSelectedName : citiesSelectedPreview;
        },
        /**
         * @returns {String} - заголовок для select
         */
        cityTitle() {
            if (this.selectedCities.length === 0) {
                return 'Выберите город'
            } else if (this.selectedCities.length === 1) {
                const selectedCityId = this.selectedCities[0]
                const selectedCity = this.cities.find(item => String(item.id) === String(selectedCityId))
                return selectedCity.value
            } else {
                return `Выделено: ${this.selectedCities.length}`
            }
        },
        /**
         * заголовок для копки даты
         * @returns {String}
         */
        dateTitle() {
            if (this.checkedDates.length === 0) {
                return 'Выберите дату'
            } else {
                let uniqueMonths = []

                this.checkedDates.forEach(item => {
                    uniqueMonths.push(item.month)
                    uniqueMonths = Array.from(new Set(uniqueMonths))
                })
                uniqueMonths = uniqueMonths.map(item => this.months[item-1])
                const result = uniqueMonths.join(', ')

                return this.checkedDates.length === 1 ? this.monthsFull.get(String(result)): `${ result }`;
            }
        },
        /**
         * @returns {Boolean}
         */
        hasChips() {
            return this.chips.length > 0
        },
        getFilterButtonClasses() {
            return {'filter-info__wrapper_has': this.hasChips}
        }
    },
	methods: {
        onOpenFilterLocations() {
            this.isFilterLocations = true;
        },
        onCloseFilterLocations() {
            this.isFilterLocations = false;
            this.filterLocationsSearchValue = '';
        },
        onApplyFilterLocations(locationsSelected = {}) {
            const filterLocationsSelected = {
                country_id: locationsSelected?.countries ?? [],
                region_id: locationsSelected?.regions ?? [],
                location_id: locationsSelected?.cities ?? [],
            };

            this.$emit('applyFilterLocations', filterLocationsSelected);
            this.onCloseFilterLocations();
        },
        onSearchFilterLocations(newLocationsSearchValue = '') {
            this.filterLocationsSearchValue = String(newLocationsSearchValue);

            this.$emit('searchFilterLocations', newLocationsSearchValue);
        },
        onAddCityFilterLocations(cityData = {}) {
            this.$emit('addCityFilterLocations', cityData);
        },
        onChangeVisibleDatepicker(boolean) {
            this.isDatepickerOpen = boolean
        },
        /**
         * включаю/выключаю фильтр
         */
		onFilterToggle() {
			this.$emit('toggle')
		},
        /** -
         * @param {Array} event - массив объектов в формате {year: 2022, month: 6}
         */
        onApproveDatepicker(event) {
            this.$refs?.refLinceDatepickerMonth?.close();
            this.$emit('approveDatepicker', event)
        },
        closeDatepicker() {
            this.$refs?.refLinceDatepickerMonth?.close();
        },
        /**
         * @param {Object} chipsData
         * событие удаления чипса
         */
        onRemoveChips(chipsData) {
            this.$emit('removeChips', chipsData);
        },
        /**
         * Найти количество отображаемых chips в текущей ширине контейнера
         */
        getVisibleChips(isReducedWidth = false) {
            this.maxWidthChips = this.$refs?.chipsWrap?.clientWidth ?? 0;
            // this.maxHeightChips = this.$refs.chipsWrap.clientHeight;

            const paddingChip = 20;
            const paddingChips = 30;
            const marginChips = 5;
            const oneSymbolWidth = this.chips.length > 5 ? 7.2 : 7.4;
            let chipsWidth = 0;
            let chipsCount = 0;
            let reduceConstant = 0;

            if (isReducedWidth) {
                reduceConstant = 39;
            }

            for (const chip of this.chips) {
                const chipWidth = Math.round((chip.value.length * oneSymbolWidth) + paddingChip);
                if ((chipsWidth + chipWidth) >= (this.maxWidthChips - paddingChips - reduceConstant)) {

                    if (chipsWidth + (reduceConstant / 3) >= this.maxWidthChips - paddingChips - reduceConstant) {
                        if (chipsCount > 0) {
                            chipsCount--;
                            break;
                        }
                    }
                    break;
                } else {
                    chipsWidth += Math.round(chip.value.length * oneSymbolWidth) + paddingChip;
                    if (chipsCount > 1) {
                        chipsWidth += marginChips;
                    }
                    chipsCount++;
                }
            }

            if (chipsCount === 0) {
                chipsWidth = 0;
            }

            this.countVisibleChips = chipsCount;

        },
        /**
         * При событии Resize вызвать функцию пересчета кол-ва отображаемых chips
         */
        getWrapperWidth() {
            let isReduced = false;
            const resizedWidth = document.documentElement.clientWidth;
            if (resizedWidth < this.loadClientWidth) {
                isReduced = true;
            }
            this.isResize = true;
            this.loadClientWidth = resizedWidth;
            this.getVisibleChips(isReduced);
        },
        onClear() {
			this.$emit('clear');
		}
	},
}
</script>

<style lang="scss" scoped>
$primary-color: 			#F0F3F8 !default; //#6EC87A !default
$primary-lighten-color: 	#F9FAFB !default;
$primary-disabled-color: 	#DCE1E8 !default;
$assistant-color: 			#ADB0BB !default;
$active-color: 				#4A92F6 !default;
$active-darker-color: 		#1f79d2 !default;
$danger-color: 				#F84967 !default;
$success-color: 			#6EC87A !default;
$success-lighten-color: 	#C5E9CA !default;
$reserved-color:			#FFB300 !default;

.filter-panel {
	display: flex;
	align-items: center;
    height: 40px;

    &__item {
        height: 100%;
        &-preloader {
            position: absolute;
            z-index: 2;
            width: 100%;
            height: 100%;
            background: white;
            top: 0;
            left: 0;
            opacity: 0.7;
            margin-left: 0px;
        }

        &-container {
            height: 100%;
            position: relative;
        }

        &-preload {
            z-index: 1;
            border-radius: 100px;
        }
    }

    &__select-title {
        font-weight: 700;
        font-size: 14px;
    }
    &__btn-container {
        display: flex;
        justify-content: flex-end;
    }

    & > div:not(&__select) {
        margin-left: 10px;
    }

    &__select {
        height: 100%;
        flex-shrink: 0;

        .select-preview {
            height: 100%;
        }
    }

    &-date {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        height: 100%;
        width: 180px;
        border-radius: 100px !important;
        padding: 0 15px;
        text-align: left;

        &__icon {
            flex-shrink: 0;
        }

        &__title {
            display: block;
            margin-left: 10px;
            flex-grow: 1;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
    }

    &__date-wrapper {
        height: 100%;
    }

    &-icon {
        font-size: 18px;
    }

    .filter-info {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;

        border: 1px solid #F2F4F5;
        border-radius: 1000px;

        &__wrapper {
            width: 100%;
            height: 100%;
            border-radius: 1000px;
            display: flex;

            &_has {
                border: 1px solid $primary-color;
            }

            &--resizing {
                align-items: center;
            }
        }

        &__chips-wrapper {
            display: flex;
            width: 100%;

            &--resizing {
                height: 25px;
                overflow: hidden;
            }
        }

        &__chips-place {
            display: flex;
            align-items: center;
            padding: 0 15px;

            &--resizing {
                align-items: flex-start;
            }

            .chips {
                position: relative;
                padding-right: 65px;
            }

            .chips--resizing {
                flex-wrap: wrap;
            }
        }

        &-icon {
            font-size: 18px;
        }

        &-btn {
            height: 100%;
            border-radius: 1000px;
            display: flex;
            align-items: center;
            width: 60px;
            // padding: 0 22px 0 15px;
            margin-right: 10px;

            &_active {
                // background: #fff;
                // border-color: $primary-color;
                width: 120px;
            }

            span {
                display: block;
                // margin-left: 10px;
            }

            &__text {
                margin-left: 10px;
            }
        }

        &-panel {
            &__btn {
                &-icon {
                    font-weight: 700;
                }

                &-title {
                    margin-left: 6px;
                }
            }
        }
    }

    @media screen and (max-width: 1200px) {
        &__border {
            position: absolute;
            top: 0;
            left: -20px;
            width: 300%;
            height: 1px;
            padding: 0;
            background-color: #F2F4F5;
        }
    }

    @media screen and (max-width: 577px) {
        .filter-info {
            border: none;

            &__wrapper {
                justify-content: flex-end;
            }

            .filter-info-btn {
                padding: 0 13px;
            }
        }

    }
}

.filter-panel-date.btn_active,
.filter-info-btn.btn_active {
    border-color: #6EC87A;
}
</style>

<style lang="scss">
.filter-info__chips-place .chips__btn {
    position: absolute;
    top: 0;
    right: 0;
}

.filter-panel {
    .filter-panel__select {
        width: 180px!important;
        border-radius: 100px !important;

        .select-preview {
            height: 100%;
            border-radius: 100px!important;

        }
        .select-preview.btn_active {
            border-color: #6EC87A!important;
        }
        .select-preview__label {
            font-weight: 700;
        }
    }
    .d-wrap__content-wrapper {
        height: 100%;
    }
}
</style>
